module.exports = __webpack_public_path__ + "img/sys-subtitle.d606aa33.png";